import React, { useState } from "react";
import { Card } from "antd";
import {
  Line,
  Bar,
  XAxis,
  YAxis,
  Tooltip as RechartsTooltip,
  Legend,
  ResponsiveContainer,
  ComposedChart,
  CartesianGrid,
  ReferenceLine,
} from "recharts";
import { FiFileText } from "react-icons/fi";

const EmployeeMovementLineGraph = ({ tdEmployeeMovement }) => {
  const monthNames = {
    "01": "January",
    "02": "February",
    "03": "March",
    "04": "April",
    "05": "May",
    "06": "June",
    "07": "July",
    "08": "August",
    "09": "September",
    10: "October",
    11: "November",
    12: "December",
  };

  const updatedData = tdEmployeeMovement.map((item) => ({
    month: monthNames[item.timePeriod],
    shortMonth: monthNames[item.timePeriod].slice(0, 3), 
    newEmployee: Number(item.newemployeecount) || 0,
    leaveEmployee: -Math.abs(Number(item.leavecount)) || 0,
    strength: Number(item.employeestrength) || 0,
  }));

  const maxStrength =
    updatedData.length > 0
      ? Math.max(...updatedData.map((item) => item.strength))
      : 0;
  const yAxisMax = Math.ceil(maxStrength / 10) * 10 + 10;

  const maxNewEmployee =
    updatedData.length > 0
      ? Math.max(...updatedData.map((item) => item.newEmployee)) + 2
      : 0;
  const minLeaveEmployee =
    updatedData.length > 0
      ? Math.min(...updatedData.map((item) => item.leaveEmployee)) - 2
      : 0;

  return (
    <Card style={{ border: "1px solid #0000001F", borderRadius: "16px" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{ fontWeight: "700", fontSize: "16px", marginLeft: "8px" }}
        >
          Employee Movement In Last 12 Months
        </div>
      </div>
      {updatedData.length == 0 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            height: "310px",
            color: "#9B9DA0",
            fontWeight: "700",
          }}
        >
          <span>
            <FiFileText style={{ fontSize: "60px" }} />
          </span>
          <span>No data available</span>
        </div>
      ) : (
        <ResponsiveContainer width="108%" height={310}>
          <ComposedChart
            data={updatedData}
            stackOffset="sign"
            margin={{ top: 20, right: 5, left: -30, bottom: 10 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="shortMonth"
              tick={{ angle: -45, textAnchor: "end", fontSize: 12 }}
              interval={0}
              tickLine={false}
            />
            <YAxis
              orientation="left"
              domain={[minLeaveEmployee, maxNewEmployee]}
            />
            <YAxis yAxisId="right" orientation="right" domain={[0, yAxisMax]} />
            <RechartsTooltip
              formatter={(value, name) => {
                if (name === "Employee Left") {
                  return Math.abs(value);
                }
                return value;
              }}
            />
            <Legend
              wrapperStyle={{
                fontSize: "11px",
                fontWeight: "normal",
                paddingTop: "25px",
                display: "flex",
                justifyContent: "left",
                marginLeft: "50px",
                width: "fit-content",
              }}
            />
            <ReferenceLine y={0} stroke="#cac8c8" />
            <Bar
              dataKey="newEmployee"
              fill="#0DCCCC"
              stackId="stack"
              name="New Joiners"
            />
            <Bar
              dataKey="leaveEmployee"
              fill="#F18E57"
              stackId="stack"
              name="Exits"
            />
            <Line
              yAxisId="right"
              type="monotone"
              dataKey="strength"
              stroke="#1679ff"
              strokeWidth={2}
              dot={{ r: 2 }}
              name="Total Headcount"
            />
          </ComposedChart>
        </ResponsiveContainer>
      )}
    </Card>
  );
};

export default EmployeeMovementLineGraph;
